<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('submenu.mukofot')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-1 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-2">
                          <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('mukofot.title')}}</span></div>
                        </div>
                      <div class="mt-3 py-3 text-center">
                        <div class="row">
                          <div class="col-lg-12">
                            <el-collapse v-model="activeName" accordion>
                              <el-collapse-item :title="$t('mukofot.subtitle4')"
                                                name="1" class="text-center">
                                                                <p style="text-align: justify;">{{$t('mukofot.subinfo')}}</p>
                                <span class="news_title">{{$t('mukofot.mardlik')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo6')"></p>
                                <span class="news_title">{{$t('mukofot.sodiq')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.infosodiq4')"></p>
                                <span class="news_title">{{$t('mukofot.shuxrat')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.infoshuxrat4')"></p>
                              </el-collapse-item>
                              <el-collapse-item :title="$t('mukofot.subtitle3')"
                                                name="2" class="text-center">
                                                                <p style="text-align: justify;">{{$t('mukofot.subinfo')}}</p>
                                <span class="news_title">{{$t('mukofot.jasorat')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.jasoratinfo4')"></p>
                                <span class="news_title">{{$t('mukofot.sodiq')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.infosodiq3')"></p>
                                <span class="news_title">{{$t('mukofot.shuxrat')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.infoshuxrat3')"></p>
                              </el-collapse-item>
                              <el-collapse-item :title="$t('mukofot.subtitle2')"
                                                name="3" class="text-center">
<!--                                <p style="text-align: justify;">{{$t('mukofot.subinfo')}}</p>-->
                                <!--                                  <span class="news_title">{{$t('mukofot.shonsaraf')}}</span>-->
                                <!--                                  <p style="text-align: justify;" v-html="$t('mukofot.infoshonsharaf')"></p>-->
                                <span class="news_title">{{$t('mukofot.mardlik')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo4')"></p>
                                <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo5')"></p>
                                <span class="news_title">{{$t('mukofot.dostlik')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo4')"></p>
                                <span class="news_title">{{$t('mukofot.jasorat')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.jasoratinfo2')"></p>
                                <p style="text-align: justify;" v-html="$t('mukofot.jasoratinfo3')"></p>
                                <span class="news_title">{{$t('mukofot.sodiq')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.infosodiq2')"></p>
                                <span class="news_title">{{$t('mukofot.shuxrat')}}</span>
                                <p style="text-align: justify;" v-html="$t('mukofot.infoshuxrat2')"></p>
                              </el-collapse-item>
                              <el-collapse-item :title="$t('mukofot.subtitle')"
                                            name="4" class="text-center">
                            <p style="text-align: justify;">{{$t('mukofot.subinfo')}}</p>
                            <!--                                  <span class="news_title">{{$t('mukofot.shonsaraf')}}</span>-->
                            <!--                                  <p style="text-align: justify;" v-html="$t('mukofot.infoshonsharaf')"></p>-->
                            <span class="news_title">{{$t('mukofot.mardlik')}}</span>
                            <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo')"></p>
                            <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo2')"></p>
                            <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo3')"></p>
                            <span class="news_title">{{$t('mukofot.dostlik')}}</span>
                            <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo')"></p>
                            <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo2')"></p>
                            <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo3')"></p>
                            <span class="news_title">{{$t('mukofot.jasorat')}}</span>
                            <p style="text-align: justify;" v-html="$t('mukofot.jasoratinfo')"></p>
                            <span class="news_title">{{$t('mukofot.sodiq')}}</span>
                            <p style="text-align: justify;" v-html="$t('mukofot.infosodiq')"></p>
                            <span class="news_title">{{$t('mukofot.shuxrat')}}</span>
                            <p style="text-align: justify;" v-html="$t('mukofot.infoshuxrat')"></p>
                          </el-collapse-item>
                            </el-collapse>
                          </div>
                        </div>

<!--                        <div class="mt-3 py-3 border-top text-center">-->
<!--                          <div class="row justify-content-center">-->
<!--                            <div class="col-lg-11">-->
<!--                              <span class="news_title">{{$t('mukofot.subtitle')}}</span>-->
<!--                              <p style="text-align: justify;">{{$t('mukofot.subinfo')}}</p>-->
<!--                              &lt;!&ndash;                                  <span class="news_title">{{$t('mukofot.shonsaraf')}}</span>&ndash;&gt;-->
<!--                              &lt;!&ndash;                                  <p style="text-align: justify;" v-html="$t('mukofot.infoshonsharaf')"></p>&ndash;&gt;-->
<!--                              <span class="news_title">{{$t('mukofot.mardlik')}}</span>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo')"></p>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo2')"></p>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.mardlikinfo3')"></p>-->
<!--                              <span class="news_title">{{$t('mukofot.dostlik')}}</span>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo')"></p>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo2')"></p>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.dostlikinfo3')"></p>-->
<!--                              <span class="news_title">{{$t('mukofot.jasorat')}}</span>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.jasoratinfo')"></p>-->
<!--                              <span class="news_title">{{$t('mukofot.sodiq')}}</span>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.infosodiq')"></p>-->
<!--                              <span class="news_title">{{$t('mukofot.shuxrat')}}</span>-->
<!--                              <p style="text-align: justify;" v-html="$t('mukofot.infoshuxrat')"></p>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->

                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style scoped>
::v-deep .el-collapse-item__header {
  height: 48px;
  line-height: normal;
  text-align: left;
}
</style>
